import { render } from "./VideoComments.vue?vue&type=template&id=d0c80502"
import script from "./VideoComments.vue?vue&type=script&lang=js"
export * from "./VideoComments.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mohamedyousef/projects/online_education/projects/web-applications/admin-panel-for-education-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__